import { render, staticRenderFns } from "./AdminEventList.vue?vue&type=template&id=55e8e2a6"
import script from "./AdminEventList.vue?vue&type=script&lang=js"
export * from "./AdminEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports